import _ from 'underscore';
import { getCommonFilterConfig } from '@bingads-webui-campaign/common-grid-config';
import { cloneDeep } from '@bingads-webui-universal/primitive-utilities';
import { productGroupLevel } from '../constant';

export function getFilterConfig(deps, level, bidOption = 0) {
  const IsCPGForBSCEnabled = _.result(deps.config.get('Permissions'), 'IsCPGForBSCEnabled');
  return getCommonFilterConfig({
    featureName: 'newProductGroupsGrid',
    editor: true,
    i18n: deps.i18n,
    entitySchema: deps.s$ProductGroup,
    sessionStore: deps.sessionStore,
    preferenceStoreFactory: deps.preferenceStoreFactory,
    globalConfig: deps.config,
    schemaI18nCampaign: deps.s$i18n,
    cacheService: deps.cacheService,
    dataContextManager: deps.dataContextManager,
    jsdata: deps.jsdata,
    schemaProcessor: {
      updateEntitySchemaForFeatures: (originalSchema) => {
        const updatedSchema = cloneDeep(originalSchema);
        if (!IsCPGForBSCEnabled) {
          updatedSchema.properties = _.omit(updatedSchema.properties, ['BidBoostMultiplier']);
        }
        if (level === productGroupLevel.Account) {
          return updatedSchema;
        }
        if (level === productGroupLevel.Campaign) {
          updatedSchema.properties = _.omit(updatedSchema.properties, 'CampaignName');
        }
        if (level === productGroupLevel.AdGroup) {
          updatedSchema.properties = _.omit(updatedSchema.properties, ['CampaignName', 'AdGroupName']);
          if (bidOption === 0) {
            updatedSchema.properties = _.omit(updatedSchema.properties, ['BidBoostMultiplier']);
          } else {
            updatedSchema.properties = _.omit(updatedSchema.properties, ['BidAmountBidAmount']);
          }
        }
        return updatedSchema;
      },
    },
  });
}
